// import React, { useEffect, useRef } from 'react';
// import Odometer from 'odometer';
// import debounce from 'lodash.debounce';
// import {useLocation } from "react-router-dom";
// const  CodeForOdometer = () => {
//   const observer = useRef(null);
//   const location = useLocation();
//   useEffect(() => {
//     const handleAppear = (entries) => {
//       entries.forEach(entry => {
//         if (entry.isIntersecting) {
//           const element = entry.target;
//           const countNumber = parseInt(element.getAttribute("data-count"), 10); // Parse as integer
//           if (isNaN(countNumber)) return; //Guard clause if number is not valid

//           if (element.classList.contains('xbo')) {
//             if (element.classList.contains('xb-odm')) {
//               const odometerInstance = new Odometer({
//                 el: element,
//                 value: 0,
//                 format: 'd',
//                 duration: 1500, // Duration of the animation in milliseconds (adjust as needed)
//                 // easing: "ease-in-out" // you can add easing if you want, but default is good.
//               });
//               odometerInstance.update(countNumber);
//             } else {
//               // Animate text content change for non-odometer elements
//               let currentNumber = parseInt(element.textContent, 10) || 0;
//               const increment = Math.ceil(Math.abs(countNumber - currentNumber) / 40); // Adjust divisor for speed
//               const interval = setInterval(() => {
//                 currentNumber += increment;
//                 element.textContent = currentNumber;
//                 if (currentNumber >= countNumber) {
//                   element.textContent = countNumber; // Ensure final value is correct
//                   clearInterval(interval);
//                 }
//               }, 30); // Adjust interval for speed
//             }

//             observer.current.unobserve(element);
//           }
//         }
//       });
//     };

//     const debouncedHandleAppear = debounce(handleAppear, 100);

//     observer.current = new IntersectionObserver(debouncedHandleAppear, {
//       rootMargin: "-150px 0px -150px 0px",
//     });

//     const xboElements = document.querySelectorAll(".xbo");
//     xboElements.forEach(element => observer.current.observe(element));

//     return () => {
//       if (observer.current) {
//         xboElements.forEach(element => observer.current.unobserve(element));
//       }
//     };
//   }, [location.pathname]);

//   return null;
// };

// export default CodeForOdometer;


import React, { useEffect, useRef } from 'react';
import Odometer from 'odometer';
import { useLocation } from "react-router-dom";

const CodeForOdometer = () => {
  const observer = useRef(null);
  const location = useLocation();

  useEffect(() => {
    const handleAppear = (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const element = entry.target;
          const countNumber = parseInt(element.getAttribute("data-count"), 10);
          if (isNaN(countNumber)) return; // Exit if countNumber is invalid

          // Use Odometer if the element has the 'xb-odm' class
          if (element.classList.contains('xb-odm')) {
            const odometerInstance = new Odometer({
              el: element,
              value: 0,
              format: 'd',
              duration: 1500,
            });
            odometerInstance.update(countNumber);
          } else {
            // Animate the number manually using requestAnimationFrame for smoother performance
            const initialNumber = parseInt(element.textContent, 10) || 0;
            const duration = 1500; // Duration in milliseconds
            const difference = countNumber - initialNumber;
            let startTime = null;

            const animate = (timestamp) => {
              if (!startTime) startTime = timestamp;
              const progress = Math.min((timestamp - startTime) / duration, 1);
              const currentNumber = Math.floor(initialNumber + difference * progress);
              element.textContent = currentNumber;
              if (progress < 1) {
                requestAnimationFrame(animate);
              } else {
                element.textContent = countNumber; // Ensure final value is correct
              }
            };

            requestAnimationFrame(animate);
          }

          // Stop observing the element once it's animated
          observer.current.unobserve(element);
        }
      });
    };

    // Create the observer without debouncing for immediate response
    observer.current = new IntersectionObserver(handleAppear, {
      rootMargin: "-150px 0px -150px 0px",
      threshold: 0,
    });

    // Observe all elements with the 'xbo' class
    const elements = document.querySelectorAll(".xbo");
    elements.forEach(element => observer.current.observe(element));

    // Cleanup on component unmount or path change
    return () => {
      if (observer.current) {
        elements.forEach(element => observer.current.unobserve(element));
      }
    };
  }, [location.pathname]);

  return null;
};

export default CodeForOdometer;
